var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('ConfirmDialog',{ref:"confirmdialog"}),(_vm.$vuetify.breakpoint.mdAndUp)?_c('TopBar'):_vm._e(),_c('v-main',{staticClass:"background"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }